import { MfsState } from './interfaces';
import { useMfsStore } from './mfsStore';
import { SET_RATER_NOMINATION_DETAILS, SET_RATING_ID, SET_NEW_ADDED_RATER_ID } from './mfsAction';
import { RaterNominationDetails } from '../interfaces/RaterNominationDetails';

/** Initial state for MfsStoreProvider */
export const initialMfsState: MfsState = {
  raterNominationDetails: {
    introContent: '',
    languages: [],
    page: {
      total: 0,
      min: 0,
      max: 0,
      disableAddNewRater: false,
      raters: [],
    },
  },
  ratingId: '',
  newAddedRaterId: '',
};

/**  Store for Mfs */
interface RaterNominationStore {
  details: RaterNominationDetails;
  ratingId: string;
  newAddedRaterId: string;
  setRaterNominationDetails: (details: RaterNominationDetails) => void;
  setRatingId: (id: string) => void;
  setNewAddedRaterId: (id: string) => void;
}

export const useRaterNominationDetails = (): RaterNominationStore => {
  const { mfsState, dispatch } = useMfsStore();
  return {
    details: mfsState.raterNominationDetails,
    ratingId: mfsState.ratingId,
    newAddedRaterId: mfsState.newAddedRaterId,
    setRaterNominationDetails: (details: RaterNominationDetails): void =>
      dispatch({ type: SET_RATER_NOMINATION_DETAILS, payload: details }),
    setRatingId: (id: string): void => dispatch({ type: SET_RATING_ID, payload: id }),
    setNewAddedRaterId: (id: string): void => dispatch({ type: SET_NEW_ADDED_RATER_ID, payload: id }),
  };
};
